import React, { useState } from 'react';
import { Check, Copy } from 'lucide-react';
import toast from 'react-hot-toast';

interface GmudIdBadgeProps {
  id: number;
  // Quando true, o clique copia "#id" para a área de transferência
  copiavel?: boolean;
  className?: string;
}

// Identificador da GMUD (#403), usado na listagem e no detalhe
const GmudIdBadge: React.FC<GmudIdBadgeProps> = ({ id, copiavel = false, className = '' }) => {
  const [copiado, setCopiado] = useState(false);
  const base =
    'inline-flex items-center gap-1 rounded-md bg-gray-100 px-2 py-0.5 font-mono text-xs font-semibold text-gray-700';

  if (!copiavel) {
    return (
      <span className={`${base} ${className}`} title={`GMUD #${id}`}>
        #{id}
      </span>
    );
  }

  const copiar = async () => {
    try {
      await navigator.clipboard.writeText(`#${id}`);
      setCopiado(true);
      toast.success(`ID #${id} copiado`);
      window.setTimeout(() => setCopiado(false), 2000);
    } catch {
      toast.error('Não foi possível copiar o ID');
    }
  };

  return (
    <button
      type='button'
      onClick={copiar}
      title='Copiar ID da GMUD'
      className={`${base} hover:bg-gray-200 transition-colors ${className}`}
    >
      #{id}
      {copiado ? <Check className='h-3 w-3 text-green-600' /> : <Copy className='h-3 w-3' />}
    </button>
  );
};

export default GmudIdBadge;
